(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
function orderFooterLinks() {
  document.querySelectorAll('.footer-link-group').forEach(group => {
    const links = Array.from(group.children).filter(element => element.tagName === 'A' && !element.hasAttribute('data-footer-pinned'));
    const measured = links.map((link, index) => {
      const range = document.createRange();
      range.selectNodeContents(link);
      return { link, index, width: range.getBoundingClientRect().width };
    });
    measured.sort((a, b) => a.width - b.width || a.index - b.index);
    measured.forEach(({ link }) => group.appendChild(link));
  });
}
if (document.fonts) document.fonts.ready.then(orderFooterLinks);
else orderFooterLinks();
document.addEventListener('shopify:section:load', orderFooterLinks);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
function initHomeHeroes(root = document) {
  root.querySelectorAll('[data-home-hero]').forEach(hero => {
    if (hero.dataset.heroReady) return;
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const controls = hero.querySelector('[data-hero-controls]');
    const buttons = [...controls.querySelectorAll('[data-hero-select]')];
    const status = hero.querySelector('[data-hero-status]');
    const stage = hero.querySelector('[data-hero-stage]');
    const playback = hero.querySelector('[data-hero-playback]');
    const previous = hero.querySelector('[data-hero-previous]');
    const next = hero.querySelector('[data-hero-next]');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const controller = new AbortController();
    const listen = (target, name, callback, options = {}) => target.addEventListener(name, callback, {...options, signal: controller.signal});
    let current = 0;
    let timer;
    let animations = [];
    let paused = motion.matches;
    let hovered = false;
    let focused = false;
    let visible = false;
    let touchStart = null;
    const schedule = () => {
      clearTimeout(timer);
      if (!paused && !hovered && !focused && visible && !document.hidden && !touchStart) {
        timer = setTimeout(() => select(current + 1, false, 1), 6000);
      }
    };
    const showPlayback = () => {
      playback.dataset.paused = String(paused);
      playback.setAttribute('aria-label', paused ? playback.dataset.playLabel : playback.dataset.pauseLabel);
      schedule();
    };
    const select = (index, announce = true, direction = index > current ? 1 : -1) => {
      const target = (index + slides.length) % slides.length;
      const outgoing = slides[current];
      const changed = target !== current;
      animations.forEach(animation => animation.cancel());
      animations = [];
      slides.forEach(slide => slide.classList.remove('is-leaving'));
      current = target;
      slides.forEach((slide, position) => {
        const active = position === current;
        slide.classList.toggle('is-active', active);
        slide.inert = !active;
        slide.setAttribute('aria-hidden', String(!active));
        buttons[position].setAttribute('aria-pressed', String(active));
      });
      if (changed && !motion.matches) {
        outgoing.classList.add('is-leaving');
        const timing = {duration: 560, easing: 'cubic-bezier(.22,.75,.25,1)'};
        const exit = outgoing.animate([{transform:'translateX(0)'},{transform:`translateX(${-direction * 100}%)`}], timing);
        const enter = slides[current].animate([{transform:`translateX(${direction * 100}%)`},{transform:'translateX(0)'}], timing);
        exit.onfinish = () => outgoing.classList.remove('is-leaving');
        animations = [exit, enter];
      }
      if (announce) status.textContent = buttons[current].textContent.trim();
      schedule();
    };
    hero.dataset.heroReady = 'true';
    slides.forEach(slide => { slide.hidden = false; });
    controls.hidden = false;
    hero.querySelector('[data-hero-arrows]').hidden = false;
    select(0, false);
    showPlayback();
    buttons.forEach((button, index) => listen(button, 'click', () => select(index)));
    listen(previous, 'click', () => select(current - 1, true, -1));
    listen(next, 'click', () => select(current + 1, true, 1));
    listen(playback, 'click', () => { paused = !paused; showPlayback(); });
    listen(hero, 'keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
      if (!event.target.closest('[data-hero-select], [data-hero-previous], [data-hero-next]')) return;
      if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
      event.preventDefault();
      const index = event.key === 'Home' ? 0 : event.key === 'End' ? slides.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
      select(index);
      buttons[current].focus();
    });
    listen(hero, 'pointerenter', event => { if (event.pointerType === 'mouse') { hovered = true; schedule(); } });
    listen(hero, 'pointerleave', event => { if (event.pointerType === 'mouse') { hovered = false; schedule(); } });
    listen(hero, 'focusin', () => { focused = true; schedule(); });
    listen(hero, 'focusout', event => { focused = hero.contains(event.relatedTarget); schedule(); });
    listen(document, 'visibilitychange', schedule);
    listen(motion, 'change', () => { if (motion.matches) { paused = true; animations.forEach(animation => animation.finish()); } showPlayback(); });
    listen(stage, 'touchstart', event => {
      touchStart = event.touches.length === 1 ? {x:event.touches[0].clientX,y:event.touches[0].clientY} : null;
      schedule();
    }, {passive:true});
    listen(stage, 'touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - touchStart.x;
      const dy = touch.clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) select(current + (dx < 0 ? 1 : -1), true, dx < 0 ? 1 : -1);
      else schedule();
    }, {passive:true});
    listen(stage, 'touchcancel', () => { touchStart = null; schedule(); }, {passive:true});
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; schedule(); }, {threshold: 0.35});
    observer.observe(stage);
    listen(document, 'shopify:section:unload', event => {
      if (!event.target.contains(hero)) return;
      clearTimeout(timer);
      observer.disconnect();
      animations.forEach(animation => animation.cancel());
      controller.abort();
    });
  });
}
initHomeHeroes();
document.addEventListener('shopify:section:load', event => initHomeHeroes(event.target));

  } catch(e) { console.error(e); }
})();
})();
